module.exports = __webpack_public_path__ + "img/12.19468c36.png";